// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"1ad0a2e1","631":"dae97818","774":"e3ce1de4","787":"1fee1fb8","854":"f6a92f09","858":"9f41850a"}[chunkId] + ".chunk.js";
};